import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { userAppContext } from '../../Context/Context';
import { citationCount } from '../../Constants/Constants';
import { trackHomeButtonClick } from '../../utils/analytics';
import { getHomeCarouselStats } from '../../utils/statsParser';

function Container() {
  const [homeInfo, setHomeInfo] = useState([
    '30K+ disease genes',
    '14M+ evidences',
    '38K+ diseases & traits',
    '1.6M+ disease variants',
  ]);
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(false);
  const paragraphRef = useRef(null);
  const { restrictSources } = userAppContext();

  useEffect(() => {
    // Load dynamic stats from stats.json
    const loadStats = async () => {
      try {
        const stats = await getHomeCarouselStats();
        setHomeInfo(stats);
      } catch (error) {
        console.error('Error loading stats, using fallback values:', error);
        // Keep the initial hardcoded values in state as fallback
      }
    };
    loadStats();
  }, []);

  useEffect(() => {
    updateHomeInfo();
    const interval = setInterval(updateHomeInfo, 5000);
    return () => clearInterval(interval);
  }, [homeInfo]);

  const updateHomeInfo = () => {
    setCurrentInfoIndex(prevIndex => (prevIndex + 1) % homeInfo.length);
    setFadeIn(true);
    setTimeout(() => {
      setFadeIn(false);
    }, 4000);
  };

  const currentText = homeInfo[currentInfoIndex];
  const navigate = useNavigate();

  const handleBrowseAllClick = () => {
    trackHomeButtonClick('Browse All', 'home_browse_all');
    if (restrictSources === 'CURATED') {
      navigate({
        pathname: '/search',
        search: '?view=ALL&idents=ALL&source=CURATED&tab=GDA',
      });
    } else {
      navigate({
        pathname: '/search',
        search: '?view=ALL&idents=ALL&source=ALL&tab=GDA',
      });
    }
  };
  const handleAdvancerdFiltersClick = () => {
    trackHomeButtonClick('Advanced Search', 'home_advanced_search');
    navigate({
      pathname: '/advancedSearch',
    });
  };

  const handleAskQuestionClick = () => {
    trackHomeButtonClick('AI Assistant', 'home_ai_assistant');
    navigate({
      pathname: '/Assistant',
    });
  };

  const handleEnrichmentClick = () => {
    trackHomeButtonClick('Enrichment', 'home_enrichment');
    navigate('/enrichment');
  };

  return (
    <section style={{ textAlign: 'center' }}>
      <div className="row">
        <div className="col">
          {/* <h1 className="custom-slogan" style={{ letterSpacing: '2px' }}>
              Data for tomorrow’s health
            </h1> */}
          <h3 className="custom-home-h3 gradient-color" style={{ letterSpacing: '1px' }}>
            Unleash your research with the world&apos;s most reliable and extensive gene-disease association
            network.
          </h3>
          <div>
            <p className={`custom-home-p`} style={{ letterSpacing: '1px' }}>
              F-score 92% {' | '}
              <span className={`fade-in ${fadeIn ? 'fade-in-active' : ''}`}>{currentText}</span>
              {' | '}Cited in {citationCount}00+ papers
              {/* {' | '}Est. 2010{' | '}
              <Link to={linkUrl}>
                Browse All
                <i className="px-1 bi-arrow-right"></i>
              </Link> */}
            </p>
          </div>
          <div className="pb-4">
            <button id="home_browse_all" className="btn-gradient-pink" onClick={handleBrowseAllClick}>
              Browse All <i className="px-1 bi-arrow-right"></i>
            </button>
            <button id="home_advanced_search" className="btn-gradient-pink" onClick={handleAdvancerdFiltersClick}>
              Advanced Search
            </button>
            <button id="home_enrichment" className="btn-gradient-pink" onClick={handleEnrichmentClick}>
              Enrichment
            </button>
            <button id="home_ai_assistant" className="btn-gradient-pink" onClick={handleAskQuestionClick}>
              AI Assistant <i className="bi bi-stars"></i> <i className="px-1 bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Container;
